export default "__VITE_PUBLIC_ASSET__5ed3c688__"